import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppointmentContactChoicesControllerRequestService } from './service/appointment-contact-choices-controller-request.service';
import { IPBoardAppointmentHelper } from './helper/ip-board-appointment-helper';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import Contact from 'src/app/model/Contact/contact';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { AuthService } from 'src/app/services/auth.service';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';

@Component({
  selector: 'ip-board-appointment',
  templateUrl: './ip-board-appointment.component.html',
  styleUrls: ['./ip-board-appointment.component.scss'],
  providers: [FormatPhoneNumber],
})
export class IPBoardAppointmentComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  project: Project;

  @Input()
  projectPlacement: ProjectPlacement;

  @Input()
  hideNeedAppointment: boolean = false;

  @Input()
  hideNeedAppointmentInfo: boolean = false;

  @Input()
  client: boolean = false;

  @Input()
  disabled: boolean = false;

  @Output()
  save = new EventEmitter<any>();

  @Input()
  nullIsFalse: boolean = false;

  contactChoices: Contact[];

  flexRow = true;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private appointmentContactChoicesControllerRequestService: AppointmentContactChoicesControllerRequestService,
    private authService: AuthService,
    private formatPhoneNumber: FormatPhoneNumber
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.project.id == null) {
      this.projectPlacement.appointmentWithCustomer = true;
    }
    if (this.projectPlacement.appointmentContact != null) {
      ContactHelper.setFormDisplays(
        this.projectPlacement.appointmentContact,
        this.formatPhoneNumber
      );
    }
    this.fetchContactChoices();
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.fetchContactChoices();
      }
    );
  }

  private fetchContactChoices(): void {
    const companyIds = IPBoardAppointmentHelper.getCompanyIds(this.project);
    if (CollectionHelper.isPopulated(companyIds)) {
      this.appointmentContactChoicesControllerRequestService
        .getAppointmentContactChoices(companyIds)
        .then((choices) => {
          this.doSetContactChoices(choices);
          if (
            this.client &&
            this.projectPlacement.appointmentWithCustomer &&
            this.projectPlacement.appointmentContact == null
          ) {
            this.tryFillUserContact();
          }
        });
    } else {
      this.doSetContactChoices([]);
    }
  }

  private doSetContactChoices(choices: Contact[]): void {
    IPBoardAppointmentHelper.processContactChoices(
      choices,
      this.projectPlacement,
      this.formatPhoneNumber
    );
    this.contactChoices = choices;
  }

  private tryFillUserContact(): void {
    const matchingContact = ContactHelper.getMatchingContact(
      this.contactChoices,
      this.authService.getAuthenticatedUser()
    );
    if (matchingContact != null) {
      this.projectPlacement.appointmentContact = matchingContact;
      this.projectDisplayObservableService
        .getProjectPlacementVariableChangedSubscribable()
        .next();
    }
  }

  appointmentChange(value: boolean): void {
    this.projectPlacement.appointment = value;
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  appointmentWithCustomerChange(value: boolean): void {
    this.projectPlacement.appointmentWithCustomer = value;
    if (this.projectPlacement.appointmentWithCustomer == null) {
      this.resetCustomerFields();
      this.resetOwnerFields();
    } else if (this.projectPlacement.appointmentWithCustomer === true) {
      this.resetOwnerFields();
      if (this.client && this.projectPlacement.appointmentContact == null) {
        this.tryFillUserContact();
      }
    } else {
      this.resetCustomerFields();
    }
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  private resetCustomerFields(): void {
    this.projectPlacement.appointmentContact = null;
  }

  private resetOwnerFields(): void {
    this.projectPlacement.appointmentName = null;
    this.projectPlacement.appointmentPhoneNumber = null;
    this.projectPlacement.appointmentEmail = null;
  }

  appointmentContactChange(): void {
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  needAppointmentInfoChange(value: string): void {
    this.projectPlacement.needAppointmentInfo = value;
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  appointmentNameChange(): void {
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  appointmentPhoneNumberChange(value: string): void {
    this.projectPlacement.appointmentPhoneNumber =
      value == null ? null : this.formatPhoneNumber.transform(value);
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  appointmentEmailChange(): void {
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.save.emit();
  }

  compareEntities(o1: Contact, o2: Contact): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  trackById(index: number, obj: Contact): number {
    return GeneralHelper.trackById(index, obj);
  }
}
